import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Divider from 'components/shared/Divider/Divider';
import Typography from 'components/shared/Typography/Typography';

const PROTECTIONS = [
  {
    title: 'Full card number never stored',
    text: 'Tokenized with point-to-point encryption. Your full card number is never stored; refunds and charges stay fully protected. Good Faith Estimate attached.'
  },
  {
    title: 'Never more than you owe',
    text: 'Never more than the amount your insurance allows, whatever the final services. Good Faith Estimate attached.'
  },
  {
    title: 'Estimate, not a bill',
    text: "Your estimated portion may change based on the services you receive and your insurance company's final payment. Good Faith Estimate attached."
  }
];

// Static counterpart of `Letter/components/GfeAttachedInvoiceNote`; stays green regardless of brand.
const CheckinProtections = ({ isNarrow = false, isTiny = false }) => (
  <div className="flex flex-col gap-4 rounded-xl bg-success-to-white px-4 pb-6 pt-4">
    <div className={cn('flex items-center gap-3', isTiny && 'flex-col items-start')}>
      <Icon icon="illustration-feedback" size={88} className="shrink-0" />
      <div className="flex flex-col justify-center gap-1">
        <Typography variant="p" size="medium" weight="medium">
          Your Healthcare Exclusive Payment Protections
        </Typography>
        <Typography variant="p" size="small" className="block">
          We're committed to transparency and choice. Your Good Faith Estimate complies with the No
          Surprises Act (45 C.F.R. §149.610). Enhanced payment options are protected under our{' '}
          <span className="font-medium text-success-600 underline">Healthcare Payment Rider</span>.
          A card on file is required for every option above; it is stored as a secure token and
          charged only under the authorization you sign.
        </Typography>
      </div>
    </div>
    <Divider />
    <div className={cn('grid gap-5', isNarrow ? 'grid-cols-1' : 'grid-cols-3 px-5')}>
      {PROTECTIONS.map((item) => (
        <div key={item.title} className="flex flex-col gap-1">
          <Typography variant="p" size="medium" weight="medium" color="neutral-800">
            {item.title}
          </Typography>
          <Typography variant="p" size="small" color="neutral-800" className="block">
            {item.text}
          </Typography>
        </div>
      ))}
    </div>
  </div>
);

export default CheckinProtections;
